import {
  LOG_GET_ARTICLES_REQUEST,
  LOG_GET_ARTICLES_SUCCESS,
  LOG_GET_ARTICLES_FAIL,
  LOG_GET_CATEGORIES_REQUEST,
  LOG_GET_CATEGORIES_SUCCESS,
  LOG_GET_CATEGORIES_FAIL,
} from "../actions/log";

const initialState = {
  getArticlesRequest: false,
  getArticleRequest: false,
  getAuthorsRequest: false,
  removeArticleRequest: false,
  getCategoriesRequest: false,
  categories: [],
  errorMsg: "",
  successMsg: "",
  errors: {},
  articles: [],
  authors: [],
  articlesPagination: {},
  selectedArticle: {}
};

const log = (state = initialState, action) => {
  switch (action.type) {
    case LOG_GET_ARTICLES_REQUEST:
      return {
        ...state,
        getArticlesRequest: true,
          errorMsg: "",
          successMsg: "",
          errors: {}
      };
    case LOG_GET_ARTICLES_SUCCESS:
      return {
        ...state,
        getArticlesRequest: false,
          errorMsg: "",
          successMsg: action.msg,
          errors: {},
          articles: action.data.data,
          articlesPagination: {
            currentPage: action.data.current_page,
            lastPage: action.data.last_page,
          }
      };
    case LOG_GET_ARTICLES_FAIL:
      return {
        ...state,
        getArticlesRequest: false,
          errorMsg: action.msg,
          successMsg: "",
          errors: action.errors
      };
    case LOG_GET_CATEGORIES_REQUEST:
      return {
        ...state,
        getCategoriesRequest: true,
          errorMsg: "",
          successMsg: "",
          errors: {}
      };
    case LOG_GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        getCategoriesRequest: false,
          errorMsg: "",
          successMsg: action.msg,
          errors: {},
          categories: action.data,
      };
    case LOG_GET_CATEGORIES_FAIL:
      return {
        ...state,
        getCategoriesRequest: false,
          errorMsg: action.msg,
          successMsg: "",
          errors: action.errors
      };


    default:
      return state;
  }
};

export default log;